import React from "react";
import { motion } from "motion/react";

/**
 * LoaderComponent – Ripple Loader with Heartbeat + Text
 * Premium smooth ripple waves + breathing core + subtle text.
 * Matches Flowbite blue theme, works in dark/light mode.
 */
function LoaderComponent() {
  return (
    <div className="flex flex-col items-center justify-center py-24 w-full select-none space-y-6">
      <div className="relative w-16 h-16">
        {/* Outer ripples */}
        {[0, 1].map((i) => (
          <motion.div
            key={i}
            className="absolute inset-0 rounded-full border-4 border-blue-500"
            animate={{
              scale: [0.7, 1.5],
              opacity: [1, 0],
            }}
            transition={{
              duration: 1.8,
              delay: i * 0.6,
              repeat: Infinity,
              ease: "easeOut",
            }}
          />
        ))}

        {/* Center heartbeat pulse */}
        <div className="absolute inset-0 flex items-center justify-center">
          <motion.div
            className="w-3.5 h-3.5 bg-blue-500 rounded-full shadow-lg shadow-blue-500/30"
            animate={{
              scale: [1, 1.25, 1],
              opacity: [1, 0.9, 1],
              boxShadow: [
                "0 0 8px rgba(59,130,246,0.3)",
                "0 0 20px rgba(59,130,246,0.6)",
                "0 0 8px rgba(59,130,246,0.3)",
              ],
            }}
            transition={{
              duration: 1.6,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        </div>
      </div>

      {/* Subtle loading text */}
      <motion.p
        className="text-app-secondary font-medium tracking-wide"
        initial={{ opacity: 0.5 }}
        animate={{ opacity: [0.5, 1, 0.8, 1] }}
        transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        Loading...
      </motion.p>
    </div>
  );
}

export default LoaderComponent;
